'use client';

import { WaveformBars } from './waveform-bars';

interface WaveformLoaderProps {
  /** Loading text below the waveform */
  text?: string;
  /** Size variant */
  size?: 'sm' | 'md' | 'lg';
  /** Additional className */
  className?: string;
}

const sizeMap = {
  sm: { bars: 3, height: 16 },
  md: { bars: 4, height: 24 },
  lg: { bars: 5, height: 32 },
} as const;

export function WaveformLoader({
  text,
  size = 'md',
  className = '',
}: WaveformLoaderProps) {
  const { bars, height } = sizeMap[size];

  return (
    <div className={`flex flex-col items-center gap-3 ${className}`} role="status">
      <WaveformBars bars={bars} height={height} active />
      {text && (
        <p
          className="text-sm"
          style={{ color: 'var(--text-muted)', fontFamily: 'var(--font-body)' }}
          aria-hidden="true"
        >
          {text}
        </p>
      )}
      <span className="sr-only">{text ?? 'Loading...'}</span>
    </div>
  );
}
